import React, { useState } from 'react';
import { firebaseStorage } from '../utils/firebase';
import { Search, ArrowRight, Gift } from 'lucide-react';

const TrackOrder = ({ onBack, onApproved }) => {
    const [trackingCode, settrackingCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');

    const handleTrack = async (e) => {
        e.preventDefault();
        if (!trackingCode.trim()) return;

        setLoading(true);
        setError('');
        setResult(null);

        try {
            const gift = await firebaseStorage.trackGiftByCode(trackingCode.trim());
            if (gift) {
                setResult(gift);
            } else {
                setError('عفواً، لم نجد طلب بهذا الرقم. تأكد من إدخال الرقم الصحيح.');
            }
        } catch (err) {
            setError('حدث خطأ أثناء البحث، حاول مرة أخرى.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-indigo-950 via-purple-950 to-indigo-900 text-white p-6 text-right" dir="rtl">
            <div className="max-w-md mx-auto">
                <button onClick={onBack} className="flex items-center gap-2 text-purple-300 hover:text-white mb-8 transition-all">
                    <ArrowRight className="w-5 h-5" /> العودة للرئيسية
                </button>

                <div className="text-center mb-8">
                    <Search className="w-12 h-12 mx-auto mb-4 text-yellow-400" />
                    <h2 className="text-2xl font-bold">تتبع حالة طلبك</h2>
                    <p className="text-purple-200 text-sm mt-2">أدخل كود تتبع الطلب الخاص بك</p>
                </div>

                <form onSubmit={handleTrack} className="space-y-4 mb-8">
                    <input
                        type="text"
                        value={trackingCode}
                        onChange={(e) => settrackingCode(e.target.value)}
                        placeholder="مثال: TS-1234"
                        className="w-full px-4 py-4 rounded-xl bg-white/10 border border-white/20 text-white text-center focus:outline-none focus:border-yellow-400 text-lg font-mono"
                    />
                    <button
                        type="submit"
                        disabled={loading || !trackingCode}
                        className="w-full bg-yellow-400 hover:bg-yellow-500 text-indigo-950 font-bold py-4 rounded-xl transition-all shadow-lg disabled:opacity-50"
                    >
                        {loading ? 'جاري البحث...' : 'تتبع الآن'}
                    </button>
                    <a
                        href="https://www.tiktok.com/@two_2_souls"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full bg-yellow-400 hover:bg-yellow-500 text-indigo-950 font-bold py-4 rounded-xl transition-all shadow-lg flex items-center justify-center gap-2"
                    >
                        الدعم الفني
                    </a>
                </form>

                {error && (
                    <div className="bg-red-500/20 border border-red-500/50 p-4 rounded-xl text-center text-red-200">
                        {error}
                    </div>
                )}

                {result && (
                    <div className="bg-white/10 backdrop-blur-lg border border-white/10 rounded-2xl p-6 animate-in fade-in zoom-in duration-300">
                        <div className="flex justify-between items-center mb-6 border-b border-white/10 pb-4">
                            <span className="text-purple-300">حالة الطلب:</span>
                            <div className="flex items-center gap-2">
                                {result.paymentStatus === 'approved' ? (
                                    <div className="bg-green-500/10 border border-green-500/20 p-4 rounded-xl mb-2">
                                        <p className="text-center text-sm text-green-400 font-bold">
                                            تم قبول الطلب. قم بنسخ الرابط.
                                        </p>
                                    </div>
                                ) : (
                                    <div className="space-y-4">
                                        {result.paymentStatus === 'pending' ? (
                                            <div className="bg-white-500/10 border border-white-500/20 p-4 rounded-xl mb-2">
                                                <p className="text-center text-sm text-white-400 font-bold">
                                                    جارى مراجعة الطلب.
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="bg-red-500/10 border border-red-500/20 p-4 rounded-xl mb-2">
                                                <p className="text-center text-sm text-red-400 font-bold">
                                                    الطلب مرفوض: {result.rejectionReason || 'يرجى مراجعة بيانات الدفع'}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="space-y-3 mb-6 text-sm text-purple-100">
                            <p>• الهدية لـ: <span className="text-white font-bold">{result.recipientName}</span></p>
                            <p>• الخطة: <span className="text-white font-bold">{result.planType === 'premium' ? 'بلس' : 'بيزك'}</span></p>
                        </div>

                        {result.paymentStatus === 'approved' ? (
                            <button
                                onClick={() => onApproved(result.id)}
                                className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-4 rounded-xl flex items-center justify-center gap-2 transition-all shadow-xl"
                            >
                                <Gift className="w-5 h-5" /> الحصول على لينك الهدية
                            </button>
                        ) : result.paymentStatus === 'pending' ? (
                            <p className="text-center text-xs text-white/50 italic">
                                بمجرد موافقة الإدارة، سيظهر لك زر الحصول على اللينك هنا.
                            </p>
                        ) : (
                            <p className="text-center text-xs text-red-400">
                                يرجى التواصل مع الدعم الفني لحل المشكلة.
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TrackOrder;